import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { getLocalStorage } from "../utils";
import { useEffect } from "react";
import { AppDispatch } from "../redux/store";
import { useDispatch, useSelector } from "react-redux";
import CustomerFooter from "../components/Footer/CustomerFooter";
import CustomerNewNavbar from "../components/Navbar/customer/CustomerNavbar";
import { getUserDetails } from "../redux/actions/admin/authAction";
import { RootState } from "../redux/reducers/allReducers";
import { LOCAL_STORAGE_KEYS } from "../constants";

let count = 0;
const CustomerLayout = () => {
  const { userInfo }: any = useSelector((state: RootState) => state.user);
  const dispatch: AppDispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const device_type = searchParams.get("device_type");
  const isAuthenticated = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  const location = useLocation();

  const footerException = ["/search", "/hashtags", "/reels"];

  useEffect(() => {
    if (
      isAuthenticated &&
      // (userRole === ROLES.CUSTOMER || userRole === ROLES.SELLER) &&
      !count
    ) {
      count++;
      dispatch(getUserDetails());
    }
  }, [userInfo]);

  return (
    <div className="customer-layout">
      {/* <CustomerNavbar /> */}
      {device_type !== "mobile" && <CustomerNewNavbar />}
      <main className={device_type !== "mobile" ? "pt-14 md:pt-16" : ""}>
        <Outlet />
      </main>
      {/* {!location?.pathname?.includes("/search") && <CustomerFooter />} */}
      {!footerException.some((path: string) =>
        location.pathname?.includes(path)
      ) &&
        device_type !== "mobile" && <CustomerFooter />}
    </div>
  );
};

export default CustomerLayout;
